module.exports = __webpack_public_path__ + "media/images/z_favicon-83e2567734d1211e22a79cfada0e7262.png";